import { skipToken } from '@reduxjs/toolkit/query';
import { FilterParams } from '../domain/filter';
import { CampaignListEntry } from '../slice/schemas';
import {
  useGetCpgPartnerTrendsQuery,
  useGetCpgWeeklyTrendsQuery,
  useGetLci3WeeklyTrendChartsQuery,
} from '../slice/api';

export const useTrends = (
  filterParams: FilterParams,
  campaignListData: CampaignListEntry[]
) => {
  const trendsQueryParams =
    filterParams.selectedReportType === 'overall' && campaignListData.length > 0
      ? {
          campaign_ids: campaignListData
            .filter(
              r =>
                r.campaignType === 'visitation' &&
                r.lciVersion >= 3 &&
                r.reportType === 'weekly' &&
                (r.approvalStatus === 'approved' ||
                  r.approvalStatus === 'approved_visit_metrics')
            )
            .map(r => r.campaignId),
        }
      : skipToken;

  const { data: trendsData, isFetching: isTrendsLoading } =
    useGetLci3WeeklyTrendChartsQuery(trendsQueryParams);

  const cpgCampaigns = campaignListData.filter(
    campaignList => campaignList.campaignType === 'cpg'
  );

  const cpgWeeklyCampaignIds = cpgCampaigns
    .filter(c => c.reportType === 'weekly')
    .map(c => c.campaignId);
  const cpgPartnerCampaigns = cpgCampaigns.filter(
    c => c.reportType === 'partner'
  );

  const { data: cpgWeeklyTrendsData, isFetching: isCpgWeeklyTrendsLoading } =
    useGetCpgWeeklyTrendsQuery(
      cpgWeeklyCampaignIds.length > 0
        ? {
            campaign_ids: cpgWeeklyCampaignIds,
          }
        : skipToken
    );

  const { data: cpgPartnerTrendsData, isFetching: isCpgPartnerTrendsLoading } =
    useGetCpgPartnerTrendsQuery(
      cpgPartnerCampaigns.length > 0
        ? {
            trends: cpgPartnerCampaigns.map(campaign => ({
              campaign_id: campaign.campaignId,
              channel: campaign.partnerSlug ?? '',
            })),
          }
        : skipToken
    );

  return {
    trendsData,
    isTrendsLoading,
    cpgWeeklyTrendsData,
    isCpgWeeklyTrendsLoading,
    cpgPartnerTrendsData,
    isCpgPartnerTrendsLoading,
  };
};

export type TrendsHook = ReturnType<typeof useTrends>;
